import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce, useLocalStorage } from 'usehooks-ts'
import styled from 'styled-components'
import { BiChevronDown } from 'react-icons/bi'

const UserInput = ({
  tenant,
  colorMode,
  options,
}: {
  tenant?: object
  colorMode?: string
  options?: any
}) => {
  const [seats, setSeats] = useState(231) // max 246
  const [isClosed, setIsClosed] = useState(true)
  const [isMobile, setIsMobile] = useState(false)
  const [userProfile, setUserProfile] = useLocalStorage<{
    [x: string]: string
  }>('userProfile', {})
  type Inputdata = { [key: string]: string }

  /*
  const criteriaData = [
    { Geschlecht: ['Frau', 'Mann'] },
    {
      Alter: [
        'Unter 35',
        '36–45 Jahre',
        '46–55 Jahre',
        '56–65 Jahre',
        'Über 65',
      ],
    },
    {
      Zivilstand: [
        'Ledig',
        'Verheiratet',
        'Geschieden',
        'Eingetragene Partnerschaft',
        'Verwitwet',
      ],
    },
    {
      Ausbildung: [
        'Obligatorische Schule',
        'Lehre, Matura',
        'Hochschule, höhere Berufsbildung',
      ],
    },
    {
      Religion: [
        'Konfessionslos',
        'Protestantisch',
        'Katholisch',
        'Muslimisch',
        'Andere Religion',
      ],
    },
  ]
  */

  const openBox = function () {
    setIsClosed(false)
  }

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 768)
  }

  const changeUserProfile = function (criteria: string, choice: string) {
    // console.log('changeUserProfile', criteria, choice)
    // create an object with the criteria as key and the choice as value
    const userInput: Inputdata = userProfile
    userInput[criteria] = choice
    // console.log('userInput', userInput)
    // update inputProfile with userInput
    setUserProfile(userInput)
    // console.log('userProfile', userProfile)
    setIsClosed(false)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <UserInputWrapper
      className={
        isMobile
          ? isClosed
            ? 'mobile closed'
            : 'mobile'
          : isClosed
          ? 'desktop closed'
          : 'desktop'
      }
      onClick={() => openBox()}
    >
      <h3>Wie gut sind Sie im Parlament vertreten?</h3>
      <div className='instruction'>
        Geben Sie uns ein paar Angaben zu Ihrer Person (Ihre Daten werden nicht
        an uns übermittelt):
      </div>

      {options.map(function (item: any, index: number) {
        const title = Object.keys(item)[0]
        return (
          <>
            <div className='criteria' key={'crit-' + index}>
              <div className='title'>{title}</div>
              <div className='choices'>
                {item[title].map(function (choice: string, index: number) {
                  return (
                    <div
                      className={
                        userProfile[title] === choice
                          ? 'button active'
                          : 'button'
                      }
                      onClick={() => changeUserProfile(title, choice)}
                      key={choice}
                    >
                      <span>{choice}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          </>
        )
      })}
      {isClosed && (
        <div className='opener' onClick={() => openBox()}>
          <BiChevronDown />
        </div>
      )}
    </UserInputWrapper>
  )
}

const UserInputWrapper = styled.div`
  margin: 0 auto;
  max-width: 400px;
  text-align: center;
  background-color: var(--input-background);
  padding: 1rem 0.4rem 0.1rem;
  overflow: hidden;
  position: relative;

  .instruction {
    max-width: 70%;
    margin: 0 auto;
    font-size: 1.5rem;
    line-height: 2.2rem;
    color: var(--instruction-text);
  }

  .criteria {
    margin-top: 2.2rem;
    .title {
      font-size: 1.55rem;
      line-height: 2.2rem;
      margin-top: 3rem;
      text-transform: uppercase;
      color: var(--label-text);
    }
    .choices {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 1rem;
      padding: 0 1rem;
      margin-bottom: 1.4rem;
      .button {
        display: table;
        margin: 1rem 0 0;
        min-height: 40px;
        background-color: #fff;
        color: var(--brandblue-main);
        font-weight: 700;
        font-size: 1.5rem;
        line-height: 2rem;
        letter-spacing: 0.03rem;
        padding: 0.4rem 2rem;
        border-radius: 0.2rem;
        -webkit-box-shadow: 0px 2px 4px -4px rgba(0, 0, 0, 0.6);
        box-shadow: 0px 2px 4px -4px rgba(0, 0, 0, 0.6);
        cursor: pointer;
        &.active,
        &:hover {
          background-color: var(--button-hover);
          color: var(--button-hover-text);
        }
        span {
          display: table-cell;
          vertical-align: middle;
        }
      }
    }
  }
  &.closed {
    max-height: 330px;
    @media only screen and (max-width: 320px) {
      max-height: 345px;
    }
  }
  .opener {
    position: absolute;
    bottom: 2px;
    left: 0;
    width: 100%;
    text-align: center;
    max-height: 30px;
    padding: 0;
    font-size: 2.2rem;
    color: var(--beige-dark-1);
    background-color: var(--input-background);
    svg {
      background-color: #fff;
      border-radius: 50%;
      border: 2px solid var(--beige-dark-1);
    }
    cursor: pointer;
    &:hover {
      svg {
        opacity: 1;
        color: #fff;
        background-color: var(--brandblue-main);
        border-color: var(--brandblue-main);
      }
    }
  }
  max-height: 10000px;
  transition: max-height 2s ease-in-out;
`

export default UserInput
